module.exports = __webpack_public_path__ + "img/step16_a_remove_tray_and_box-talaria.7f77c3de.png";